/* Extra behaviors for the main product section, moved out of
   main-product-v2.liquid. Depends on jQuery (+ matchHeight, loaded in layout).
   ReCharge compare-at price is passed in via window.fcCompareAtPriceMoney. */

/* --- ReCharge subscription widget customizations --- */
  var checkExist = setInterval(function() {
  // Check if RC widget exists on the page, if not, check again in 100ms
  if (document.querySelector('.rc-widget')) {
    // Clear interval so this only runs once
    clearInterval(checkExist);
    setTimeout(function() {
      var mainSubscriptionWrap = $('.custom_product_wrap .rc-widget .subscription-radio');
      var oneTimeWrap = $('.custom_product_wrap .rc-widget .onetime-radio');
      var discountText = mainSubscriptionWrap.find('.discount-label').text().replace('Subscribe & Save', '');
      mainSubscriptionWrap.find('.discount-label').html('<div class="custom-heading">Subscribe & Save <!--<span>Recurring Charge</span>--></div>');
      mainSubscriptionWrap.find('.discount-label').after('<span class="dis-tag">Save '+ discountText +'</span>');


      setTimeout(function() {
      $('.custom_product_wrap .rc-widget').find('.rc-selling-plans').after('<span class="dis-tag-footer">Save '+ discountText +'</span>');
      }, 500);

  setTimeout(function() {
      $('.custom_product_wrap .rc-widget .onetime-radio').find('.discount-label').after('<s>' + (window.fcCompareAtPriceMoney || '') + '<s>');
      }, 500);

    }, 500);

  }
}, 100); // check every 100ms

/* --- Equalize card heights --- */
  $( document ).ready(function() {
    setTimeout(function () {
      $('.card-information__text').matchHeight();
    }, 3000);
  });
